// wp-icons — Files & Folders (13)
import { createWpIcon } from './createIcon.js';

export const FileText = createWpIcon('FileText', [
  ['path', { d: 'M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5z', key: 'a' }],
  ['polyline', { points: '14 2 14 8 20 8', key: 'b' }],
  ['line', { x1: 16, x2: 8, y1: 13, y2: 13, key: 'c' }],
  ['line', { x1: 16, x2: 8, y1: 17, y2: 17, key: 'd' }],
  ['line', { x1: 10, x2: 8, y1: 9, y2: 9, key: 'e' }],
]);
export const FileCheck = createWpIcon('FileCheck', [
  ['path', { d: 'M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5z', key: 'a' }],
  ['polyline', { points: '14 2 14 8 20 8', key: 'b' }],
  ['path', { d: 'm9 15 2 2 4-4', key: 'c' }],
]);
export const FileSignature = createWpIcon('FileSignature', [
  ['path', { d: 'M20 19.5v.5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8.5L20 7.5', key: 'a' }],
  ['path', { d: 'M14 2v6h6', key: 'b' }],
  ['path', { d: 'M3 15c2 0 2-2 4-2s2 2 4 2 2-2 4-2 2 2 4 2', key: 'c' }],
  ['path', { d: 'M3 19h18', key: 'd' }],
]);
export const FileSpreadsheet = createWpIcon('FileSpreadsheet', [
  ['path', { d: 'M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5z', key: 'a' }],
  ['polyline', { points: '14 2 14 8 20 8', key: 'b' }],
  ['path', { d: 'M8 13h2', key: 'c' }],
  ['path', { d: 'M14 13h2', key: 'd' }],
  ['path', { d: 'M8 17h2', key: 'e' }],
  ['path', { d: 'M14 17h2', key: 'f' }],
]);
export const FileWarning = createWpIcon('FileWarning', [
  ['path', { d: 'M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5z', key: 'a' }],
  ['polyline', { points: '14 2 14 8 20 8', key: 'b' }],
  ['path', { d: 'M12 12v4', key: 'c' }],
  ['path', { d: 'M12 20h.01', key: 'd' }],
]);
export const File = createWpIcon('File', [
  ['path', { d: 'M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5z', key: 'a' }],
  ['polyline', { points: '14 2 14 8 20 8', key: 'b' }],
]);
export const Folder = createWpIcon('Folder', [
  ['path', { d: 'M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9l-.81-1.2a2 2 0 0 0-1.67-.9H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2z', key: 'a' }],
]);
export const FolderOpen = createWpIcon('FolderOpen', [
  ['path', { d: 'm6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.55 6a2 2 0 0 1-1.94 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2', key: 'a' }],
]);
export const FolderPlus = createWpIcon('FolderPlus', [
  ['path', { d: 'M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9l-.81-1.2a2 2 0 0 0-1.67-.9H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2z', key: 'a' }],
  ['line', { x1: 12, x2: 12, y1: 10, y2: 16, key: 'b' }],
  ['line', { x1: 9, x2: 15, y1: 13, y2: 13, key: 'c' }],
]);
export const FolderX = createWpIcon('FolderX', [
  ['path', { d: 'M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9l-.81-1.2a2 2 0 0 0-1.67-.9H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2z', key: 'a' }],
  ['path', { d: 'm9.5 10.5 5 5', key: 'b' }],
  ['path', { d: 'm14.5 10.5-5 5', key: 'c' }],
]);
export const FolderKanban = createWpIcon('FolderKanban', [
  ['path', { d: 'M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9l-.81-1.2a2 2 0 0 0-1.67-.9H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2z', key: 'a' }],
  ['path', { d: 'M8 10v4', key: 'b' }],
  ['path', { d: 'M12 10v2', key: 'c' }],
  ['path', { d: 'M16 10v6', key: 'd' }],
]);
export const ClipboardList = createWpIcon('ClipboardList', [
  ['rect', { width: 8, height: 4, x: 8, y: 2, rx: 1, ry: 1, key: 'a' }],
  ['path', { d: 'M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2', key: 'b' }],
  ['path', { d: 'M12 11h4', key: 'c' }],
  ['path', { d: 'M12 16h4', key: 'd' }],
  ['path', { d: 'M8 11h.01', key: 'e' }],
  ['path', { d: 'M8 16h.01', key: 'f' }],
]);
export const ScrollText = createWpIcon('ScrollText', [
  ['path', { d: 'M8 21h12a2 2 0 0 0 2-2v-2H10v2a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v3h4', key: 'a' }],
  ['path', { d: 'M19 17V5a2 2 0 0 0-2-2H4', key: 'b' }],
  ['path', { d: 'M15 8h-5', key: 'c' }],
  ['path', { d: 'M15 12h-5', key: 'd' }],
]);
export const BookOpen = createWpIcon('BookOpen', [
  ['path', { d: 'M12 7v14', key: 'a' }],
  ['path', { d: 'M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z', key: 'b' }],
]);
